module.exports = __webpack_public_path__ + "img/todo.ac8f729d.svg";